import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { PATHS } from '@/routes/paths'

/**
 * 安全な「戻る」ナビゲーションフック。
 * 履歴スタックに前の画面がある場合は navigate(-1)、
 * 無い場合（PWA復帰・ディープリンク直アクセス等）は fallback 先へ遷移する。
 */
export const useGoBack = (fallback: string = PATHS.HOME) => {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(() => {
    // react-router v7: idx===0 は履歴スタックの先頭（戻れない）
    // key==='default' は初期エントリだが replace で上書きされると別キーになるため idx も併用
    const idx = (window.history.state as { idx?: number } | null)?.idx
    if (location.key !== 'default' && typeof idx === 'number' && idx > 0) {
      navigate(-1)
    } else {
      navigate(fallback, { replace: true })
    }
  }, [navigate, location.key, fallback])
}
